import { put } from 'redux-saga/effects';
import { rulesCache, get } from 'ctm-util-functions';

/**
 * Set the value for a form element on state, optionally sending a touch first.
 * @param {Object} action - The dispatched action
 */
export const setFormValue = function* (action) {
    const identifier = action.identifier;
    // First set the value so that the rules re-evaluate so we can use the latest values in the check below
    yield put({ type: 'SET_VALUE', identifier, value: action.value, stateKey: action.stateKey });

    if (action.sendTouch) {
        // this is the default touchAction - just touch the element to enable validation
        let touchAction = { type: 'ELEMENT_TOUCHED', identifier, stateKey: action.stateKey };
        const rule = rulesCache.getRuleResult(action.identifier, 'validation');

        // if an element is optional ONLY if another field is valid, we need to do some extra logic to make the validation reflect this
        // We only use optionalIfValid in a few spots - mainly for controlledLoad in energy and mobile vs home phone.
        // For now if Element1 has defined optionalIfValid to Element2, then the Element2 will have a corresponding optionalIfValid for
        // Element1
        if (rule && get(rule.elementRule, 'props.optionalIfValid')) {
            // get the validation rule for the element defined by optionalIfValid
            const dependentRule = rulesCache.getRuleResult(rule.elementRule.props.optionalIfValid, 'validation');
            if (rule.result && !dependentRule.result) {
                // in this case, the Element1 is valid, but Element2 is invalid, so reset the touch on Element2 to remove any validation styling and messages
                touchAction = { type: 'RESET_TOUCHES', identifiers: [dependentRule.elementRule.elementId], stateKey: action.stateKey };
                // also reset the value, just to be sure
                yield put({ type: 'SET_FORM_VALUE', identifier: dependentRule.elementRule.elementId, stateKey: action.stateKey, value: null });
            } else if (!rule.result && dependentRule.result) {
                // in this case, the Element2 is valid, but Element1 is invalid, so reset the touch on Element1 to remove any validation styling and messages
                touchAction = { type: 'RESET_TOUCHES', identifiers: [identifier], stateKey: action.stateKey };
                // also reset the value, just to be sure
                yield put({ type: 'SET_FORM_VALUE', identifier, stateKey: action.stateKey, value: null });
            }
        }
        yield put(touchAction);
    }
};
